import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import {featureInterface} from "./featureInterface";
import {getCurrentFeatureToolSettings, getFeatureEditPermission} from "../featuresFunctions";
import {featuresSetupUpdateFeature} from "../featuresActions";
import {hasSubscriptions} from "../../../utilities/subscriptionFunctions";
import {VISUALIZER_TYPES} from "../../../constants/dashboard";


const FeaturesSetupFeatureContentToolSettings = (props) => {

  const {feature, canEdit, featuresSetupUpdateFeature, allSubscriptions} = props;

  const toolSettings = getCurrentFeatureToolSettings(feature);

  const featureToolSettingsUpdate = (subscription, property, value) => {
    if (!canEdit) {
      return false
    }
    const newToolSettings = toolSettings.map(setting => {
      if (setting.tool === subscription) {
        setting[property] = value;
      }
      return setting
    })
    featuresSetupUpdateFeature(feature, "toolSettings", newToolSettings);
  }

  const nameValue = feature.unlinkedData && feature.unlinkedData.displayName
    ? feature.unlinkedData.displayName
    : feature.name;

  return (
    <div className="fs-feature__content fs-feature__content--without-right-side">
      <div className="fs-feature__line">
        <div className="fs-feature__line-item fs-feature__line-item--name">{nameValue}</div>
        {feature.sku ? (
          <div className="fs-feature__line-item--name">
            <FormattedMessage id="features.setup.feature.sku" />: {feature.sku}
          </div>
        ) : null}
      </div>
      <div className="fs-feature__line">
        {allSubscriptions.map(subscription => {
          let toolSettingObject = toolSettings.find(toolSetting => toolSetting.tool === subscription);
          if (!toolSettingObject) {
            toolSettingObject = {tool: subscription};
            toolSettings.push(toolSettingObject);
          }
          return (
            <div className="en-panel en-panel--feature" key={subscription}>
              <button className={"en-panel__button en-panel__button--"+VISUALIZER_TYPES[subscription]+"-vis"
                + (toolSettingObject.enableVisualizer ? ' on' : '')}
                      onClick={() => featureToolSettingsUpdate(subscription, "enableVisualizer", !toolSettingObject.enableVisualizer)}/>
              <button className={"en-panel__button en-panel__button--"+VISUALIZER_TYPES[subscription]+"-qt"
                + (toolSettingObject.enableQuotingTool ? ' on' : '')}
                      onClick={() => featureToolSettingsUpdate(subscription, "enableQuotingTool", !toolSettingObject.enableQuotingTool)}/>
              <span className="en-panel__text fs-feature__sku">{subscription}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
};

FeaturesSetupFeatureContentToolSettings.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = (store) => {
  const {canEdit} = getFeatureEditPermission(store);
  const {allSubscriptions} = hasSubscriptions(store);

  return {
    canEdit,
    allSubscriptions,
  };
};

const mapDispatchToProps = {
  featuresSetupUpdateFeature,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupFeatureContentToolSettings)
)
